//This mutation is purely for resettting transactions with testim runs
//DO NOT USE OTHERWISE!!!!
import graphql from 'babel-plugin-relay/macro';
import { commitMutation } from 'react-relay';
import AbEnvironment from '../auth/AbEnvironment'; 
  
  const abEnvironment = new AbEnvironment();
  const mutation = graphql`
  mutation ResetBindCardTransactionMutation($input: ResetbindcardtransactionInput!) {
    resetbindcardtransaction(input: $input) {
      integer
    }
  }
  `;

  function commit(bindcardid) {
    const variables = {
      input: {
        bindcardid
      }
    }
    
    return new Promise((resolve, reject) => {
      commitMutation(
        abEnvironment.getEnvironment(), {
          mutation,
          variables,
          onCompleted: (response) => {
            resolve(response);
          },
          onError: (error) => {
            reject(error);
          }
      });
    });
  }
  /* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
  export default { commit };
  